// extracted by mini-css-extract-plugin
export default {"container":"Card_container__9Ahnb","left":"Card_left__Hli8h","right":"Card_right__acWnt"};